export function pad(num, size) {
  var s = num + '';
  while (s.length < size) s = '0' + s;
  return s;
}

export function getImageUrl(url) {
  return process.env.REACT_APP_API_URL + url;
}



// WEBPACK FOOTER //
// ./src/utils/index.js